import GuideMessage from "../components/GuideMessage";

const UniversitySpaceGuideMessage = () => {
    return (
        <GuideMessage>
            <p>
                Si deseas visualizar los espacios registrados previamente, <b>debes completar todos los campos del filtro de búsqueda</b> y hacer clic en Aplicar.
            </p>
        </GuideMessage>
    )
}

export default UniversitySpaceGuideMessage;